import DashboardView from './views/Dashboard/DashboardView';
import AuthNavigation from './views/Auth/AuthNavigation';

export default function MyApp() {
  const token = localStorage.getItem('token360');

  if (!token) {
    return <AuthNavigation />;
  }

  return <DashboardView />;
}
